const searchToolWrapperCls = "_61s1rhiaxx";

// The quicksearch alters the search button when expanded, the snippet below
// prepares that transition.
const searchButtonCls = "_61s6kfsvr";

export { searchButtonCls, searchToolWrapperCls };
import "./tool.search.style.linaria.module.css";
//# sourceMappingURL=tool.search.style.js.map
